import { Component, input, Input, InputSignal, output } from '@angular/core';
import { LargeFamilyCardAppEntityLargeFamilyCardWrite } from '../../../../../../../openapi';
import { AlertComponent } from '../../../../../../../common/alert/alert.component';
import { AccordionGroupComponent } from '../../../../../../../common/accordion-group/accordion-group.component';
import { AccordionItemComponent } from '../../../../../../../common/accordion-item/accordion-item.component';
import { LabelComponent } from '../../../../../../../common/label/label.component';

@Component({
  selector: 'app-large-family-cards-preview',
  standalone: true,
  imports: [
    AlertComponent,
    AccordionGroupComponent,
    AccordionItemComponent,
    LabelComponent
  ],
  templateUrl: './large-family-cards-preview.component.html'
})
export class LargeFamilyCardsPreviewComponent {
  @Input()
  public expanded: boolean = true;

  public showActions = input(false);

  public canEdit = input(true);

  public onRemove = output<number>();

  public onEdit = output<{ v: LargeFamilyCardAppEntityLargeFamilyCardWrite, i: number }>();

  public cards: InputSignal<LargeFamilyCardAppEntityLargeFamilyCardWrite[]> = input<LargeFamilyCardAppEntityLargeFamilyCardWrite[]>([]);
}
